import { AxiosError } from "axios";

export const isAxios = (error: any, code: number, message?: string) => {
    return (
        error instanceof AxiosError &&
        error.response?.status === code &&
        (!message || error.response?.data.message === message)
    );
};
